export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('draggable', {
    mounted(el, binding) {
      const handler = {
        posX: 0,
        posY: 0,
        initialMouseX: 0,
        initialMouseY: 0,
        lastmove: 0,

        // add a flag to know if we actually dragged
        dragged: false,
        isMousedUpped: false,

        // one-time click blocker
        preventClick(event: MouseEvent) {
          event.preventDefault()
          event.stopPropagation()
          document.removeEventListener('click', handler.preventClick, true)
        },

        onMouseMove(event: MouseEvent) {
          event.preventDefault()
          event.stopPropagation()

          if(handler.isMousedUpped){
            return;
          }

          if (Date.now() - handler.lastmove < 10) {
            return;
          }

          event.stopPropagation()
          // mark as dragged
          handler.dragged = true


          // microseconds
          handler.lastmove = Date.now()

          const dx = event.pageX - handler.initialMouseX + handler.posX
          const dy = event.pageY - handler.initialMouseY + handler.posY

          el.style.transform = `translate(${dx}px, ${dy}px)`
          el.style.zIndex = '9000' // bring to front

          if (!el.dataset.dragging && handler.dragged && event.clientX && event.clientY) {
            document.dispatchEvent(new CustomEvent('noticesDragging', {
              detail: {
                element: el,
                clientX: event.clientX,
                clientY: event.clientY,
                isDragging: true
              }
            }))
          }

          // data-dragged to true
          el.setAttribute('data-dragged', 'true')
        },
        async onMouseUp(event: MouseEvent) {
          handler.isMousedUpped = true

          document.removeEventListener('mousemove', handler.onMouseMove)
          document.removeEventListener('mouseup', handler.onMouseUp)

          // if we actually moved, block the next click
          if (handler.dragged) {
            document.addEventListener('click', handler.preventClick, true)
          }else{
            return
          }

          // add transition all
          el.style.transition = 'transform 0.2s ease-out'

          // reset transform
          el.style.transform = ''
          el.style.zIndex = '' // reset z-index

          setTimeout(() => {
            // remove transition
            el.style.transition = ''
          }, 200)

          el.setAttribute('data-dragged', 'false')

          document.dispatchEvent(new CustomEvent('draggable-drop', {
            detail: {
              element: el,
              clientX: event.clientX,
              clientY: event.clientY
            }
          }))

          document.dispatchEvent(new CustomEvent('noticesDragging', {
            detail: {
              element: el,
              clientX: event.clientX,
              clientY: event.clientY,
              isDragging: false
            }
          }))
        },
        onMouseDown(event: MouseEvent) {
          // event.preventDefault()
          // event.stopPropagation()

          // reset drag flag
          handler.dragged = false
          handler.isMousedUpped = false
          // read current transform
          const style = window.getComputedStyle(el)
          const transform = style.transform

          if (transform && transform !== 'none') {
            const m = new DOMMatrixReadOnly(transform)
            handler.posX = m.m41
            handler.posY = m.m42
          } else {
            handler.posX = 0
            handler.posY = 0
          }
          handler.initialMouseX = event.pageX
          handler.initialMouseY = event.pageY

          setTimeout(() => {
            document.addEventListener('mousemove', handler.onMouseMove)
            document.addEventListener('mouseup', handler.onMouseUp)
          },20);

          // if noticesDragging on another element then stop dragging this
          const onNoticesDragging = (e: any) => {
            if (e.detail.isDragging && e.detail.element !== el) {
              handler.onMouseUp(e as any)
            }
            document.removeEventListener('noticesDragging', onNoticesDragging)
          }
          document.addEventListener('noticesDragging', onNoticesDragging)
        }
      };

      (el as any).__draggableHandlers = handler

      // only attach if the bound value is truthy
      if (binding.value) {
        el.addEventListener('mousedown', handler.onMouseDown)
      }
    },

    // new: toggle listener just before update if value changed
    beforeUpdate(el, binding) {
      const handler = (el as any).__draggableHandlers
      if (!handler || binding.value === binding.oldValue) return

      (binding.value)
        ? el.addEventListener('mousedown', handler.onMouseDown)
        : el.removeEventListener('mousedown', handler.onMouseDown)
    },

    // 3) watch for changes on the binding and attach/detach
    updated(el, binding) {
      const handler = (el as any).__draggableHandlers
      if (!handler || binding.value === binding.oldValue) return

      (binding.value)
        ? el.addEventListener('mousedown', handler.onMouseDown)
        : el.removeEventListener('mousedown', handler.onMouseDown)
    },

    // 4) always clean up on unmount
    unmounted(el) {
      const handler = (el as any).__draggableHandlers
      if (handler) {
        el.removeEventListener('mousedown', handler.onMouseDown)
      }
    }
  })
})
